import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from 'theme';
import { sessionKey } from 'reducer/rAuth';

import 'css/index.css';
import "css/scss/style.scss";
import Main from 'component/Main';
import reportWebVitals from 'reportWebVitals';
import store from 'store';
import './i18n';

/**
 * 뒤로가기로 되살아난 문서가 인증 상태를 잘못 들고 있으면 버린다.
 *
 * <p>로그인과 로그아웃은 문서를 새로 연다. 그래서 뒤로가기 스택에는 <b>그 전 상태로
 * 만들어진 문서</b>가 남는다. 브라우저가 그것을 bfcache 에서 통째로 되살리면 모듈도
 * effect 도 다시 돌지 않아, 화면만 옛날 것이 된다 — 로그인했는데 로그인 화면이
 * 그대로 보이거나(로그아웃당한 줄 안다), 로그아웃했는데 목록이 남아 있다.</p>
 *
 * <p>부팅 때의 상태와 지금이 <b>다를 때만</b> 다시 읽는다. 같으면 그냥 두는 편이
 * 스크롤 위치와 입력을 지키므로 낫다.</p>
 */
const bootedAuthenticated = Boolean(window.localStorage.getItem(sessionKey));
window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    if (Boolean(window.localStorage.getItem(sessionKey)) !== bootedAuthenticated) {
        window.location.reload();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<ThemeProvider theme={theme}>
		<Provider store={store}>
			<React.Suspense>
				<BrowserRouter>
					<Main />
				</BrowserRouter>
			</React.Suspense>
		</Provider>
	</ThemeProvider>
);
// 애플리케이션 초기화 시에 checkLoginStatus 함수 호출
// checkLoginStatus();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
